import { z } from 'zod';

import { SettingCategory } from '../config/config-registry';

// Setting categories — derived from the config registry enum
export const settingCategorySchema = z.nativeEnum(SettingCategory);

// Setting entity schema
export const settingSchema = z.object({
  id: z.string().uuid(),
  key: z.string().min(1),
  label: z.string().min(1),
  value: z.string().nullable(),
  description: z.string().nullable(),
  category: z.string(),
  is_secret: z.boolean(),
  has_value: z.boolean().optional(),
  sort_order: z.number(),
  created_at: z.date().or(z.string().datetime()),
  updated_at: z.date().or(z.string().datetime()),
});

export type Setting = z.infer<typeof settingSchema>;

// Update setting schema
export const updateSettingSchema = z.object({
  value: z.string().nullable(),
});

export type UpdateSettingDto = z.infer<typeof updateSettingSchema>;

// Bulk update settings schema
export const bulkUpdateSettingsSchema = z.object({
  settings: z.array(
    z.object({
      key: z.string().min(1),
      value: z.string().nullable(),
    }),
  ),
});

export type BulkUpdateSettingsDto = z.infer<typeof bulkUpdateSettingsSchema>;

// Settings query schema
export const settingsQuerySchema = z.object({
  category: settingCategorySchema.optional(),
});

export type SettingsQuery = z.infer<typeof settingsQuerySchema>;
